// English

const lang = {
  gateMediaPreviewHeader: 'You may also like',
  loadmore: 'Show more',
  nextMedia: 'Next media',
  previousMedia: 'Previous media',
  closePost: 'Close post',
  nextPost: 'Next post',
  previousPost: 'Previous post',
  outOfStock: 'Out of stock',
  numberOfReviews(n) {
    return n === 1 ? 'review' : 'reviews'
  },
  reportFormField: 'Please enter a message',
  reportPost: 'Report post',
  reportFormTitle: 'Do you want to report this image?',
  reportFormDetails:
    'If you believe that the image is inappropriate, illegal or infringes someone’s rights, you can report the content. If you report the image / text, the content moderators will be notified and the appropriate action will be taken.',
  reportFormMessagePlaceholder: 'State the reason for your report',
  reportFormMessageLabel: 'Message',
  reportFormEmailLabel: 'Your email',
  reportFormSubmitButtonText: 'Submit Report',
  reportFormCancelButtonText: 'Cancel',
  reportFormSentTitle: 'Thank you for your report!',
  reportFormSentCloseButtonText: 'Close',
  cardAndTileAriaLabel: 'Below is a list of posts from accounts on various social media platforms',
  carouselAriaLabel:
    'Below is a carousel with posts from accounts on various social media platforms',
  singleAriaLabel: 'Below is a post from a social media account',
  poweredBy: 'Powered by Flowbox',
  postAltText: (userName, date) => {
    const createdByString = userName ? ` by ${userName}` : ''
    const publishedString = date ? ` published at ${date}` : ''
    return `Photo${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Upload your Media',
  openTheGate: 'Open the dialog',
}

export default lang
